import React from "react";

const CardIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="1" width="6" height="6" rx="1" />
    <rect x="9" y="1" width="6" height="6" rx="1" />
    <rect x="1" y="9" width="6" height="6" rx="1" />
    <rect x="9" y="9" width="6" height="6" rx="1" />
  </svg>
);

const TableIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M2 4H14M2 8H14M2 12H14" />
  </svg>
);

export default function ViewToggle({ view, onChange, storageKey }) {
  const handleChange = (v) => {
    onChange(v);
    if (storageKey) localStorage.setItem(storageKey, v);
  };

  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-btn ${view === "card" ? "active" : ""}`}
        onClick={() => handleChange("card")}
        title="Card view"
      >
        <CardIcon />
      </button>
      <button
        className={`view-toggle-btn ${view === "table" ? "active" : ""}`}
        onClick={() => handleChange("table")}
        title="Table view"
      >
        <TableIcon />
      </button>
    </div>
  );
}
